module.exports = __webpack_public_path__ + "a2a8466eb5249eea3040e3e27020c1ad.svg";